import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { LandingPage } from './pages/LandingPage';
export function App() {
  return <LanguageProvider data-id="element-0">
      <LandingPage data-id="element-1" />
    </LanguageProvider>;
}